import {
  GetAnualidadProyecto,
  GetAnualidadProyectosOptions
} from "../../../reducers/comisionAnualidad";
import * as actions from "../../../actions/comisionAnualidad";
import { Preview } from "../../../../types/IAction";

export interface ResumenClubDispatcher {
  getProyectoByPeriodo: (
    periodo: string,
    alcancesActuales?: boolean
  ) => Promise<Preview<GetAnualidadProyecto>>;
  getProyectosOptions: () => Promise<Preview<GetAnualidadProyectosOptions>>;
  clearAnualidadProyecto: () => Promise<Preview<GetAnualidadProyecto>>;
}

export const resumenClubDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => ResumenClubDispatcher = dispatch => ({
  getProyectoByPeriodo: (periodo: string, alcancesActuales?: boolean) => {
    return dispatch(actions.getProyectoByPeriodo(periodo, alcancesActuales));
  },
  getProyectosOptions: () => {
    return dispatch(actions.getProyectosOptions());
  },
  clearAnualidadProyecto: () => {
    return dispatch(actions.clearAnualidadProyecto());
  }
});
